import { Component } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';

@Component({
  selector: 'app-button-manage-approval-renderer',
  template: `
  <style>
  .row-action-btns {
    display: flex;
    align-items: center;
    gap: 8px;
    min-width: 150px;
  }
  .row-action-btns button {
    width: 30px;
    height: 30px;
    padding: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 10px;
    transition: all .4s;
  }
  .row-action-btns button .mat-button-wrapper {
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 0;
    width: 100%;
    height: 100%;
  }
  .row-action-btns i {
    line-height: 1;
  }
  </style>
  <div class="row-action-btns">
    <button (click)="onClick($event, 'view')" mat-mini-fab style="background-color: blue;"
            matTooltip="View" aria-label="View">
      <i class="fa fa-eye" style="color:#fff;"></i>
    </button>
    <button (click)="onClick($event, 'approve')" mat-mini-fab style="background-color: #2e7d32;"
            matTooltip="Approve" aria-label="Approve">
      <i class="fa fa-check" style="color:#fff;"></i>
    </button>
    <button (click)="onClick($event, 'viewMatrix')" mat-mini-fab style="background-color: #6a1b9a;"
            matTooltip="View Matrix" aria-label="View Matrix">
      <i class="fa fa-th-large" style="color:#fff;"></i>
    </button>
  </div>
  `
})
export class ButtonManageApprovalRendererComponent implements ICellRendererAngularComp {
  params: any;
  label!: string;

  agInit(params: any): void {
    this.params = params;
    this.label = this.params.label || null;
  }

  refresh(): boolean {
    return true;
  }

  onClick(event: any, action: string) {
    if (typeof this.params.onClick === 'function') {
      this.params.onClick({
        event,
        action,
        rowData: this.params.node?.data
      });
    }
  }
}
